const {RECOMMENDED_PROVIDER_GET} = require('app/www/constants/reducer-recommended');

function reducer_RecommendedProvider(state, action) {
    switch (action.type) {
        case RECOMMENDED_PROVIDER_GET:
            state = Object.assign({}, action.payload);
            break;
        default:
            state = state || {};
            break;
    }

    return state;
}

module.exports = reducer_RecommendedProvider;
